import {main_phaser} from "../framework/src/engine/madnes/MadnesApp";
import {he, multi, wi} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_add_group, madnes_add_sprite, madnes_add_to_group, madnes_key_exist,
    madnes_remove_from_group, madnes_remove_sprite, madnes_set_scale,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_tween_bezier, madnes_tween_func, madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {madnes_anim_add, madnes_anim_loop, madnes_anim_stop} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_fill_range} from "../framework/src/engine/madnes/madnes";
import {getRandomFloat, getRandomInt} from "../framework/src/helpers";
import {getRandRadius} from "./helpers";

var coins_positions = {};

var coinsAddInterval = 320;

function getPointsPositions(pos, i) {
    return {
        'x': coins_positions[pos][i]['x'],
        'y': coins_positions[pos][i]['y'],
        'd': coins_positions[pos][i]['d']
    };
}

export function coins_create() {

    var game_width_half = (wi / 2);
    var game_height_half =  (he / 2);

    //var center_top = (he / 2.7);
    var center_bottom = (he / 3.2);


    coins_positions = {
        'centerTop' : [
            { 'x': game_width_half, 'y': game_height_half /*center_top + 50*/, 'd': 50},
            { 'x': game_width_half, 'y': 250, 'd': 150},
            { 'x': game_width_half - 300, 'y': -500, 'd': 600},
            { 'x': game_width_half + 300, 'y': -500, 'd': 600}
        ],
        'leftTop': [
            { 'x': game_width_half/* - 120*/, 'y': game_height_half /*center_top + 30*/, 'd': 1 },
            { 'x': game_width_half - 240, 'y': 100, 'd': 120},
            { 'x': game_width_half - 750, 'y': -50, 'd': 500},
            { 'x': game_width_half - 800, 'y': 350/ multi, 'd': 500}
        ],
        'rightTop': [
            { 'x': game_width_half/* + 120*/, 'y': game_height_half /*center_top + 30*/, 'd': 0 },
            { 'x': game_width_half + 240, 'y': 200, 'd': 60},
            { 'x': game_width_half + 750, 'y': -50, 'd': 500},
            { 'x': game_width_half + 800, 'y': 350, 'd': 500}
        ],
        'leftBottom': [
            { 'x': game_width_half/* - 120*/, 'y': game_height_half /*center_bottom * 2 - 90*/, 'd': 0 },
            { 'x': game_width_half - 140, 'y': center_bottom * 2 - 10, 'd': 50},
            { 'x': game_width_half - 650, 'y': center_bottom * 2 + 250, 'd': 350},
            { 'x': game_width_half - 320, 'y': center_bottom * 2 + 320, 'd': 370}
        ],
        'centerBottom' : [
            { 'x': game_width_half, 'y': game_height_half /*center_bottom * 2 - 90*/, 'd': 0 },
            { 'x': game_width_half, 'y': 250, 'd': 150},
            { 'x': game_width_half - 200, 'y': 900, 'd': 500},
            { 'x': game_width_half + 200, 'y': 900, 'd': 500}
        ],
        'rightBottom' : [
            { 'x': game_width_half/* + 120*/, 'y': game_height_half /*center_bottom * 2 - 90*/, 'd': 0 },
            { 'x': game_width_half + 140, 'y': center_bottom * 2 - 10, 'd': 50},
            { 'x': game_width_half + 650, 'y': center_bottom * 2 + 250, 'd': 350},
            { 'x': game_width_half + 320, 'y': center_bottom * 2 + 320, 'd': 370}
        ],
        'center' : [
            { 'x': game_width_half, 'y': game_height_half, 'd': 0 },
            { 'x': game_width_half - 300, 'y': game_height_half - 400, 'd': 200},
            { 'x': game_width_half + 300, 'y': game_height_half - 400, 'd': 200}
            //{ x: wi / 2 - 200, y: he / 2 + 100, d: 300 },
            //{ x: wi / 2 + 200, y: he / 2 + 100, d: 300 }
        ]
    };

    madnes_add_group("group_coins");

    //console.log(coins_positions["center"][1].d, coins_positions["center"][2].d);

    /*coins_add_area(coins_positions["leftTop"][0].x, coins_positions["leftTop"][0].y, coins_positions["leftTop"][0].d | 0, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["leftTop"][1].x, coins_positions["leftTop"][1].y, coins_positions["leftTop"][1].d | 0, Phaser.Color.getColor(50, 130, 250));
    coins_add_area(coins_positions["leftTop"][2].x, coins_positions["leftTop"][2].y, coins_positions["leftTop"][2].d | 0, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["leftTop"][3].x, coins_positions["leftTop"][3].y, coins_positions["leftTop"][3].d | 0, Phaser.Color.getColor(50, 50, 50));*/

    //coins_add_area(coins_positions["center"][1].x, coins_positions["center"][1].y, coins_positions["center"][1].d | 0, Phaser.Color.getColor(50, 50, 50));
    //coins_add_area(coins_positions["center"][2].x, coins_positions["center"][2].y, coins_positions["center"][2].d | 0, Phaser.Color.getColor(50, 50, 50));
    /*coins_add_area(coins_positions["centerBottom"][0].x, coins_positions["centerBottom"][0].y, 20, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["centerBottom"][1].x, coins_positions["centerBottom"][1].y, 20, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["centerBottom"][2].x, coins_positions["centerBottom"][2].y, 600, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["centerBottom"][3].x, coins_positions["centerBottom"][3].y, 600, Phaser.Color.getColor(50, 50, 50));*/

    /*coins_add_area(coins_positions["rightBottom"][0].x, coins_positions["rightBottom"][0].y, 20, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["rightBottom"][1].x, coins_positions["rightBottom"][1].y, 20, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["rightBottom"][2].x, coins_positions["rightBottom"][2].y, 600, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["rightBottom"][3].x, coins_positions["rightBottom"][3].y, 600, Phaser.Color.getColor(50, 50, 50));*/

    /*coins_add_area(coins_positions["center"][0].x, coins_positions["center"][0].y, 20, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["center"][1].x, coins_positions["center"][1].y, 20, Phaser.Color.getColor(50, 50, 50));
    coins_add_area(coins_positions["center"][2].x, coins_positions["center"][2].y, 600, Phaser.Color.getColor(50, 50, 50));*/

}

function coins_add_area(x, y, d, c) {

    //console.log(x, y, d, c);

    var graphics = main_phaser.add.graphics(0, 0);
    graphics.lineStyle(1, c, 1);
    graphics.drawCircle(x / multi , y / multi , d / multi );
}

/**
 * @param {string} type
 * @param {number=} dir
 * @returns {Array}
 */
function generatePointsFor(type, dir){
    var points = [];

    if(typeof dir === 'undefined')
    {
        dir = Math.random() >= 0.5 ? -1 : 1;
    }

    points.push({ 'x': getPointsPositions(type, 0)['x'], 'y': getPointsPositions(type, 0)['y'] });

    switch(type) {

        case "leftTop":
        case "rightTop":
        case "leftBottom":
        case "rightBottom":

            //p1 = getPointsPositions(type, 1);
            //points.push({ x: ((p1.x + getRandRadius(p1.d)) | 0), y: ((p1.y + getRandRadius(p1.d)) | 0) });

            if(dir < 0) {
                var p2 = getPointsPositions(type, 2);
            } else {
                var p2 = getPointsPositions(type, 3);
            }

            points.push({ 'x': ((p2['x'] + getRandRadius(p2['d'])) | 0), 'y': ((p2['y'] + getRandRadius(p2['d'])) | 0) });

            break;

        case "centerTop":
        case "centerBottom":

            if(Math.abs(getRandomInt(0, getPointsPositions(type, 1)['d'] / 2) * dir) < 30) {

                points.push({ 'x': ((wi / 2 + getRandomInt(0, 600) * dir) | 0), 'y': type === "centerTop" ? -300 : he + 300 });

            } else {

                if(dir < 0) {
                    var p1 = getPointsPositions(type, 2);
                } else {
                    var p1 = getPointsPositions(type, 3);
                }

                points.push({ 'x': ((p1['x'] + getRandRadius(p1['d'])) | 0), 'y': ((p1['y'] + getRandRadius(p1['d'])) | 0) });
            }

            break;

        case "center":

            if(dir < 0) {

                var p1 = getPointsPositions(type, 1);
                points.push({ 'x': coin_calc_pos(p1['x'], p1['d']), y: coin_calc_pos(p1['y'], p1['d']) });

                var from = 120;
                to = (wi / 2)- 160;

                points.push({ 'x': getRandomInt(from, to), 'y': he + 800});

            } else {

                var p1 = getPointsPositions(type, 2);
                points.push({ 'x': coin_calc_pos(p1['x'], p1['d']), y: coin_calc_pos(p1['y'], p1['d']) });

                var from = (wi / 2)+ 160;
                var to =  wi- 120;

                points.push({ 'x': getRandomInt(from, to), 'y': he + 800});
            }

            break;
    }

    return points;
}

function randomize_coin_frames(frames)
{
    var rIdx = getRandomInt(1, frames.length - 2);

    var a1 = frames.slice(0, rIdx);
    var a2 = frames.slice(rIdx, frames.length);

    return a2.concat(a1);
}

/**
 * @param {string} where
 * @param {boolean} explode
 * @param {number=} dir
 */
function coin_add(where, explode, dir) {
    var pos = getPointsPositions(where, 0);
    var coinId = "coin_" + ((Math.random() * 1000000) | 0);

    if(madnes_key_exist(coinId)) {
        //console.log(coinId + " exists");
        return;
    }

    madnes_add_sprite(coinId, "coins_json", pos.x, pos.y, 1, 0.5, 0.5);
    madnes_anim_add(coinId, "anim", randomize_coin_frames(madnes_fill_range(0, 45)));
    madnes_anim_loop(coinId, "anim", 30);

    //madnes_set_scale(coinId, 0.6, 0.6);
    //madnes_set_angle(coinId, getRandomInt(0, 360));
    madnes_add_to_group("group_coins", coinId);

    var duration;

    if(explode) {
        duration = getRandomFloat(1.2, 1.8);
    } else if(where === "center") {
        duration = 1.8;
        madnes_set_scale(coinId, 0.7, 0.7);
    } else {
        duration = getRandomFloat(1.2, 2.4);
    }

    (function(coinId, where) {

        var points = generatePointsFor(where, dir);

        var xx = [];
        var yy = [];

        for(var i = 0; i < points.length; i++) {
            xx.push(points[i].x);
            yy.push(points[i].y);
        }

        var tween = madnes_tween_to(coinId, { 'x': xx, 'y': yy }, {
            'duration': (duration * 1000) | 0,
            'easing': madnes_tween_func("linear"), //where === "center" ? madnes_tween_func("linear") : madnes_tween_func("quartic_in"),
            'callback': function() {
                madnes_anim_stop(coinId);
                madnes_remove_from_group("group_coins", coinId);
                madnes_remove_sprite(coinId);
            }
        });

        madnes_tween_bezier(tween);

    } (coinId, where));
}

var coins_big_win_anims = {
    "leftTop": null,
    "centerTop": null,
    "rightTop": null,
    "leftBottom": null,
    "centerBottom": null,
    "rightBottom": null
};

function coins_interval_anim_type(type, addInterval)
{
    coins_big_win_anims[type] = setInterval(coin_add.bind(this, type), addInterval);
}

export function coins_anim_bigwin_play() {
    for(var type in coins_big_win_anims) {
        coins_interval_anim_type(type, coinsAddInterval);
    }
}

export function coins_anim_bigwin_stop() {
    for(var type in coins_big_win_anims) {
        clearInterval(coins_big_win_anims[type]);
    }
}

export function coins_explode_bigwin(type) {

    var coinCount = 10;

    switch(type) {
        case "megawin":
            coinCount = 16;
            break;
        case "supermegawin":
            coinCount = 24;
            break;
        /*case "bigwin":
        default:
            coinCount = 10;
            break;*/
    }

    for(var i = 0; i < coinCount; i++) {

        for(var j in coins_big_win_anims) {
            coin_add(j, true);
        }
    }
}

/*function coins_explode(type) {

	setInterval(function() {
		coin_add(type, true);
	}, 100);

}*/

var coins_win_anims = {
    "anim1": null,
    "anim2": null
};

export function coins_anim_win_play()
{
    coins_show();
    for(var i = 0; i < 6; i++) {
        coin_add("center", false, i % 2 === 0 ? -1 : 1);
        //console.log(i % 2 === 0 ? -1 : 1);
    }

    coins_win_anims["anim1"] = setInterval(coin_add.bind(this, "center", false, -1), 500);
    coins_win_anims["anim2"] = setInterval(coin_add.bind(this, "center", false, 1), 500);
}

export function coins_anim_win_stop() {
    clearInterval(coins_win_anims["anim1"]);
    clearInterval(coins_win_anims["anim2"]);
}

export function coins_hide()
{
    madnes_set_visible("group_coins", false);
}

export function coins_show()
{
    madnes_set_visible("group_coins", true);
}

function coin_calc_pos(pos, d) {
    return (pos + getRandRadius(d)) | 0;
}